<table-list
    #listagemLicencas
    [resource]="licencasResource"
    [service]="admLicencasService"
    [filterConfiguration]="filterConfiguration"
></table-list>
